import React from 'react';
import PermButton from '../../core/utils/PermButton';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilteredCarriers, selectCarrierLoading } from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { fetchCarrierById } from './store/slice';

const { CARRIERS_ADD_EDIT } = MODAL_TYPES;

const CarrierTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredCarriers(state),
    isLoading: selectCarrierLoading(state),
  }));

  const handleEditClick = async record => {
    const id = record?.id;
    if (!id) return;
    const result = await dispatch(fetchCarrierById(id));
    const payload = result?.payload;
    if (result?.type?.endsWith('/fulfilled')) {
      dispatch(showModal(CARRIERS_ADD_EDIT, payload));
    }
  };

  const columns = [
    {
      title: 'Carrier Name',
      dataIndex: 'carrierName',
      sorter: (a, b) => (a.carrierName || '').length - (b.carrierName || '').length,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => (a.status || '').length - (b.status || '').length,
      render: (text, record) => (
        <span
          style={{
            backgroundColor: record.backGroundColor,
            color: record.textColor,
            padding: '4px 8px',
            borderRadius: '4px',
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (_text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action justify-content-start">
            <PermButton perm="MASTERS.CARRIER.EDIT">
              <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
                <i data-feather="edit" className="feather-edit"></i>
              </Link>
            </PermButton>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default CarrierTable;

